export default [
  {
    path: '',
    name: 'shop order payments list',
    component: () => import('@/views/app/shop-order-payments/page-list.vue'),
    meta: { title: 'Daftar Konfirmasi Pembayaran Pesanan' },
  },
]
